<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="部门管理" name="first"></el-tab-pane>
        <el-tab-pane label="班组管理" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="main_content">
      <component :is="activeName === 'first' ? 'DepartmentIndex' : 'TeamgroupIndex'"></component>
    </div>
  </div>
</template>

<script>
import DepartmentIndex from './components/DepartmentIndex.vue';
import TeamgroupIndex from './components/TeamgroupIndex.vue';
  export default {
    components: {
      DepartmentIndex,
      TeamgroupIndex
    },
    data() {
      return {
        activeName: 'first'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';

/deep/.main {
  background: none;
}
</style>